export default "__VITE_ASSET__BNvvcPbH__"